import {Routes} from "@angular/router";
import {MedicineStickersViewComponent} from "./view-components/medicines-stickers-view/medicines-stickers-view.component";
import {CreateStickerSheetViewComponent} from "./view-components/create-sticker-sheet-view/create-sticker-sheet-view.component";
import {StickerSheetsViewComponent} from "./view-components/sticker-sheets-view/sticker-sheets-view.component";
import {MedicineStickersNavigationComponent} from "./components/medicine-stickers-navigation/medicine-stickers-navigation.component";
import {StickersAuthorizedGuard} from "./guards/stickers-authorized.guard";
import {MedicinesViewComponent} from "./view-components/medicines-view/medicines-view.component";
import {StickerFormatsViewComponent} from "./view-components/sticker-formats-view/sticker-formats-view.component";

export const medicineStickersRoutes: Routes = [
  {
    path: 'spritzenetiketten',
    component: MedicineStickersNavigationComponent,
    canActivate: [StickersAuthorizedGuard],
    children: [
      {
        path: '',
        canActivateChild: [StickersAuthorizedGuard],
        children: [
          {
            path: 'dashboard',
            component: MedicinesViewComponent
          },
          {
            path: 'medikamente',
            component: MedicinesViewComponent
          },
          {
            path: 'beschriftungsformate',
            component: StickerFormatsViewComponent
          },
          {
            path: 'standard',
            children: [
              {
                path: 'druckboegen/neu',
                component: MedicineStickersViewComponent
              },
            ]
          },
          {
            path: 'individuell',
            children: [
              {
                path: 'druckboegen/neu',
                component: CreateStickerSheetViewComponent
              },
              {
                path: 'druckboegen',
                component: StickerSheetsViewComponent
              },
            ]
          },
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
          },
        ]
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/medicine-stickers-routing.ts